import { ApiExDate, ApiMarketDataProviderType } from '../../../api/_legacy/generated-api'
import { ExDateDistribution, ExDateReinvestment } from '../../../components/core-v2/organisms'
import { formatToServerDateFromStr } from '../../../utilities/date'

export enum ExDateStatus {
  UnDef = -1,
  Waiting,
  FinSwitchReceived,
  UserSubmitted
}

export interface ExDateSchedule {
  dateStr: string
  distributionStatus: ExDateStatus
  finSwitchDistribution: ExDateDistribution
  finSwitchReinvestment: ExDateReinvestment
  finalDistribution: ExDateDistribution
  finalReinvestment: ExDateReinvestment
  providerType: ApiMarketDataProviderType
  reinvestmentStatus: ExDateStatus
  totalDistributionValue: number
  unitsHeld: number
}

export const createEmptySchedule = (apiExDate: ApiExDate): ExDateSchedule => {
  const exDate = apiExDate.date
  return {
    dateStr: exDate,
    providerType: apiExDate.provider,
    unitsHeld: 0,
    distributionStatus: ExDateStatus.Waiting,
    reinvestmentStatus: ExDateStatus.Waiting,
    totalDistributionValue: 0,
    finSwitchDistribution: {
      readOnly: true,
      dividendPerShare: undefined,
      interestPerShare: undefined,
      capitalPerShare: undefined,
      totalPerShare: 0
    },
    finalDistribution: {
      readOnly: false,
      dividendPerShare: undefined,
      interestPerShare: undefined,
      capitalPerShare: undefined,
      totalPerShare: 0
    },
    finSwitchReinvestment: {
      readOnly: true,
      numberOfUnits: 0,
      reinvestmentDate: undefined
    },
    finalReinvestment: {
      readOnly: false,
      numberOfUnits: 0,
      reinvestmentDate: formatToServerDateFromStr(exDate)
    }
  }
}
